export default __webpack_public_path__ + "static/media/gallery_11.8bf2f1df.jpg";